<template>
	<modal
		:modal-id="modalId"
		:title="modalTitle"
		:preloader="preloader"
		@submit="submit"
		@close-modal="closeModal"
	>
		<template slot="body">
			<app-overlay-loader v-if="preloader" />
			<form
				class="mb-0"
				:class="{ 'loading-opacity': preloader }"
				ref="form"
                method="PUT"
				:data-url="`transaction/lead/${this.value.id}`"
			>

				<div class="form-group row align-items-center">
					<label for="inputs_student_id" class="col-sm-3 mb-0">
						Student Id
					</label>
					<app-input
						id="inputs_student_id"
						class="col-sm-9"
						type="text"
						v-model="inputs.student_id"
						placeholder="Student Id"
						:required="true"
					/>
				</div>
			</form>
		</template>
	</modal>
</template>

<script>
import { FormMixin } from "../../../../../../core/mixins/form/FormMixin.js";
import { ModalMixin } from "../../../../../Mixins/ModalMixin";

export default {
	name: "StudentIdForm",
	mixins: [FormMixin, ModalMixin],
	props: {
		tableId: String,
		formId: String,
		value: {
			type: Object,
			default: () => {
				return {
					code: "",
					name: "",
					is_active: "",
				};
			},
		},
	},
	data() {
		return {
			preloader: false,
			modalId: this.formId,
			modalTitle: this.$t("add"),
			inputs: {
				id: "",
				student_id: "",
			},
		};
	},
	created() {
        this.inputs.student_id = this.value.student_id;
        this.inputs.id = this.value.id;
        this.modalTitle = this.$t("edit");
	},
	methods: {
		
		submit() {
			this.save(this.inputs);
		},
		afterSuccess(response) {
			this.$toastr.s(response.data.message);
           
            this.$emit("updated");

            this.$emit("close-modal");
		},
		
		afterSuccessFromGetEditData(response) {
			this.inputs.id = response.data.id;
			this.inputs.student_id = response.data.student_id;
			this.preloader = false;
		},
	},
};
</script>
<style scoped>
::v-deep(.modal-body) {
  min-height: 38vh !important;
}
</style> 